module.exports = __webpack_public_path__ + "img/A213_vue_pers.8b7c37d5.png";